export const environment = {
  production: false,
  brands: {
    enelx: {
      globalNavUrl: 'https://global-nav-v2.dev-svcs.enernoc.net/api/v2'
    }
  },
  cdn: 'https://cdn.dev-apps.enelx.net',
  defaults: {
    brand: 'enelx',
    locale: 'en-us',
    apiLocale: 'en_US'
  }
};
